<div class="dropzone" RxUploadZone (files)="getFiles($event)" (droppedFiles)="onDroppedFiles($event)">
  <div class="text-wrapper">
    <div class="centered">
      <ng-content></ng-content>
    </div>
  </div>
</div>
